/**
 * Implement Gatsby's Browser APIs in this file.
 */
import React from 'react'; // Required for wrapPageElement
import NotFoundPage from './src/pages/404'; // IMPORT YOUR 404 PAGE COMPONENT HERE

import './src/assets/css/fonts.css';
import './src/assets/css/modern-normalize.css';
import './src/assets/css/misc.css';
import './src/assets/css/style.css';
import './src/assets/css/media.css';
import './src/bootstrap';
import './src/assets/css/modal-video.scss';
import { scrollTo } from "./src/components/utility/utils";
import { captureUTMParams, getStoredUTMParams } from './src/util/util';
import { navigate } from 'gatsby';

// --- NEW SECTION: INTERCEPT RENDERING ---
// export const wrapPageElement = ({ element, props }) => {
//     // Check if the path contains 2 or more consecutive slashes
//     if (props.location && /\/{2,}/.test(props.location.pathname)) {
//         // If yes, ignore the intended page (element) and render the 404 component
//         return <NotFoundPage {...props} />;
//     }
    
//     // Otherwise, render the normal page
//     return element;
// };
// ----------------------------------------

export const shouldUpdateScroll = ({ prevRouterProps, routerProps }) => {
    document.body.classList.add("kuda-hide")
    const hide = () => {
        document.body.classList.remove("kuda-hide")
    }
    scrollTo(0, hide);
};

export const onClientEntry = () => {
    window.onload = () => {
        window.scrollTo(0, 0)
    }
}
// landing on the page for the firstime.
export const onInitialClientRender = () => {
  captureUTMParams();
};

export const onRouteUpdate = ({ location }) => {
  const storedUTM = getStoredUTMParams();
  if (!storedUTM) return;

  const currentParams = new URLSearchParams(location.search);
  let updated = false;

  for (const [key, value] of Object.entries(storedUTM)) {
    if (!currentParams.has(key)) {
      currentParams.set(key, value);
      updated = true;
    }
  }

  if (updated) {
    const newSearch = currentParams.toString();
    const newUrl = `${location.pathname}?${newSearch}`;
     navigate(newUrl, { replace: true });
  }
};